// extracted by mini-css-extract-plugin
module.exports = {"job-listing":"JobListing_job-listing__5J2r_","intro":"JobListing_intro__DOwB1","load-error":"JobListing_load-error__7DHN5"};